import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/logo/logo-hjp-white.png'
import _imports_1 from '@/assets/img/harapan-jaya.png'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-end relative"
}
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "text-center color-blue-grey font-semibold text-sm" }
const _hoisted_6 = { class: "list-menu mt-8" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "mb-2 header-menu text-center"
}
const _hoisted_9 = {
  key: 1,
  class: "mb-2 header-menu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropdownListMenu = _resolveComponent("DropdownListMenu")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createBlock(_component_Sidebar, {
    class: _normalizeClass(_ctx.store.state.toggleMinimizeMenu ? 'left-panel-sidebar minimized' : 'left-panel-sidebar'),
    onHide: _ctx.hiddenSidebar,
    showCloseIcon: false,
    modal: false,
    dismissable: false,
    visible: _ctx.activeSlider
  }, {
    default: _withCtx(() => [
      (_ctx.store.state.device.width < 1024)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("i", {
              class: "pi pi-times text-xl mt-4",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hiddenSidebar && _ctx.hiddenSidebar(...args)))
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.store.state.toggleMinimizeMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_0,
                width: "30"
              }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
              _createElementVNode("p", _hoisted_5, "v" + _toDisplayString(_ctx.version), 1)
            ]))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "menu mb-4",
            key: 'menu-' + idx
          }, [
            (_ctx.checkProhibitedRoles(item.prohibitedRoles))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.store.state.toggleMinimizeMenu)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, ". . ."))
                    : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(item.name), 1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (listMenu, idxList) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'list-menu-' + idxList
                    }, [
                      (_ctx.checkProhibitedRoles(listMenu.prohibitedRoles))
                        ? (_openBlock(), _createBlock(_component_DropdownListMenu, {
                            key: 0,
                            onHiddenSidebar: () => { },
                            listMenu: listMenu
                          }, null, 8, ["listMenu"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["class", "onHide", "visible"]))
}